module.exports = __webpack_public_path__ + "static/Kings-Rosemont-Private-Lanes-Design-TN-59e83ed296014bf53b7caf9f06485cbe.jpg";